import React from 'react';
import block from 'bem-cn';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';

import { NotifyModel } from 'services/models/NotifyModel';
import CrossSVG from '../img/cross.svg';

import { notificationImg } from '../type';

import './Notification.scss';

class Notification extends React.PureComponent {
  constructor(props) {
    super(props);
    this.notifyRef = React.createRef();
    this.state = {
      isDeleting: false,
      isDeleted: false,
    };
  }

  static propTypes = {
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    needClose: PropTypes.bool.isRequired,

    deleteNotify: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { needClose, closeTime } = this.props;
    const touchListener = new NotifyModel(() => this._hideNotify(), this.notifyRef.current);
    touchListener.init();
    if (needClose) {
      setTimeout(this._hideNotify, closeTime);
    }
  }

  render() {
    const b = block('notify-item');
    const { text, type } = this.props;
    return (
      <div className={b({ deleting: this.state.isDeleting }, { type })} ref={this.notifyRef}>
        <SVGInline svg={notificationImg[type]?.img || ''} className={b(`img`).toString()} />
        <span className={b('text')}>{text}</span>
        <SVGInline
          className={b('close').toString()}
          svg={CrossSVG}
          onClick={() => this._hideNotify()}
        />
      </div>
    );
  }

  _hideNotify = () => {
    const { deleteNotify, id } = this.props;
    if (!this.state.isDeleted) {
      this.setState({ isDeleting: true },
        () => setTimeout(() => {
          this.setState({ isDeleted: true });
          deleteNotify(id);
        }, 700));
    }
  }
}

export default Notification;
